import { Component, inject, OnInit } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DocumentTypeService } from '../../../../services/document-type.service';
import { DocumentType } from '../../../../models/DocumentType';
import { MatButtonModule } from '@angular/material/button';
import { AppTitleService } from '../../../../services/app-title.service';
import { MatDialog } from '@angular/material/dialog';
import { DlgAddTipoDocumentoComponent } from '../../../../commons/dlg-add-tipo-documento/dlg-add-tipo-documento.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DlgDeleteComponent } from '../../../../commons/dlg-delete/dlg-delete.component';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../../commons/toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbar, MatToolbarModule } from "@angular/material/toolbar";

@Component({
    selector: 'app-tipos-documentos',
    imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule
],
    templateUrl: './tipos-documentos.component.html',
    styleUrl: './tipos-documentos.component.scss'
})
export class TiposDocumentosComponent implements OnInit {
  tiposDocumentos: DocumentType[] = []

  displayedColumns: string[] = [ 'descripcion', 'actions'];
  dataSource = new MatTableDataSource<DocumentType>([])

  snackbarData: ScnackbarData = {}

  constructor(
    private documentTypeService: DocumentTypeService,
    public dlg: MatDialog,
    private toast: ToastService
  ) {
    inject(AppTitleService).setTitle("Tipos documentos");
  }

  ngOnInit(): void {
    this.fetchDocumentTypes()
  }

  onAddDocumentType() {
    const dialogRef = this.dlg.open(DlgAddTipoDocumentoComponent, {
      maxWidth: "50vw",
      width: "500px",
    })
    dialogRef.afterClosed().subscribe((result: DocumentType | null) => {
      if (result) {
        this.fetchDocumentTypes()
      }
    });
  }

  onDeleteDocumentType(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.documentTypeService.delete(id).subscribe({
          next: (_) => {
            this.snackbarData.message = "Tipo documento eliminado!"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "check_circle"
            this.toast.show(this.snackbarData)
            this.fetchDocumentTypes()
          },
          error: (_) => {
            this.snackbarData.message = "Error eliminando tipo documento!"
            this.snackbarData.style = SnackbarStyles.Error
            this.snackbarData.iconName = "error"
            this.toast.show(this.snackbarData)
            this.fetchDocumentTypes()
          }
        })
      }
    });
  }

  fetchDocumentTypes() {
    this.documentTypeService.list().subscribe({
      next: (response) => {
        this.tiposDocumentos = response
        this.dataSource!.data = this.tiposDocumentos
      }
    })
  }

}
